import { AuthPage } from "@pages/auth/auth_page";
import { LoginPage } from "@pages/auth/login_page";
import { BasePage } from "@pages/base_page";
import { FinancePage } from "@pages/finance/finance_page";
import { PocketInfo } from "@pages/finance/pocket/pocket_page";
import { DashboardPage } from "@pages/home/dashboard_page";
import { HomePage } from "@pages/home/home_page";
import { ProfilePage } from "@pages/home/profile_page";
import { MadingDetailPage } from "@pages/school/mading/mading_detail_page";
import { MadingListPage } from "@pages/school/mading/mading_list_page";
import { MadingPage } from "@pages/school/mading/mading_page";
import { SettingPage } from "@pages/setting/setting_page";
import { SettingUpdateAccountPage } from "@pages/setting/setting_update_account_page";
import { SubmenuGradesPage } from "@pages/submenu/submenu_grades_page";
import { SubmenuPage } from "@pages/submenu/submenu_page";
import { SubmenuPaymentPage } from "@pages/submenu/submenu_payment_page";
import { SubmenuTahfidzPage } from "@pages/submenu/submenu_tahfidz_page";
import { createBrowserRouter } from "react-router-dom";
import { SchoolPage } from "@pages/school/school_page";
import { PermitPage } from "@pages/school/permit/permit_page";
import { BiographPage } from "@pages/school/bio/biograph_page";
import { PermitDetailPage } from "@pages/school/permit/permit_detail_page";
import { HealthDataPage } from "@pages/school/health/health_data_page";
import { HealthDetailPage } from "@pages/school/health/health_detail";
import { AbsenceDataPage } from "@pages/school/absence/absence_data_page";
import { AbsenceDetailPage } from "@pages/school/absence/absence_detail_page";
import { TahfidzDataPage } from "@pages/school/tahfidz/tahfidz_data_page";
import { TahfidzDetailPage } from "@pages/school/tahfidz/tahfidz_detail_page";
import { VaDataPage } from "@pages/finance/va/va_data_page";
import { VaDetailPage } from "@pages/finance/va/va_detail_page";
import { DebtPaymentPage } from "@pages/finance/debt/debt_payment_page";
import { SubmenuFinancePage } from "@pages/submenu/submenu_finance_page";
import { CheckingAccDataPage } from "@pages/finance/checking-acc/checking_acc_data_page";
import { MonthlyBillPage } from "@pages/finance/bill/monthly_bill_page";
import { NonMonthlyBillPage } from "@pages/finance/bill/non_monthly_bill_page";
import { SubmenuPermitPage } from "@pages/submenu/submenu_permit_page";
import { PermitDataPage } from "@pages/school/permit/permit_data_page";
import { SettingChangePasswordPage } from "@pages/setting/setting_change_password_page";
import { DebtBillPage } from "@pages/finance/bill/debt_bill_page";
import { RequestVaPage } from "@pages/finance/va/request_va_page";
import { MarketplacePage } from "@pages/marketplace/marketplace_page";
import MarketplaceProductPage from "@pages/marketplace/marketplace_product_page";
import MarketplaceCheckoutPage from "@pages/marketplace/marketplace_checkout_page";
import MarketplaceHistoryPage from "@pages/marketplace/marketplace_history_page";
import NotFoundPage from "@pages/error/not_found_page";
import MarketplaceHistoryDetailPage from "@pages/marketplace/marketplace_history_detail_page";
import { MenuPage } from "@pages/home/menu_page";
import { ViolationDataPage } from "@pages/school/violation/violation_data_page";
import { ViolationDetailPage } from "@pages/school/violation/violation_detail_page";
import { AchievementDataPage } from "@pages/school/achievement/achievement_data_page";
import { AchievementDetailPage } from "@pages/school/achievement/achievement_detail_page";
import MarketplaceSettingPage from "@pages/marketplace/marketplace_setting_page";
import { TafaquhDataPage } from "@pages/school/tahfidz/tafaquh_data_page";
import { TafaquhDetailPage } from "@pages/school/tahfidz/tafaquh_detail_page";

export const linkPage = {
  // AUTH
  AUTH_LOGIN: "/auth/login",

  // HOME
  HOME_DASHBOARD: "/home/dashboard",

  HOME_SUGGESTION_FORM: "/home/suggestion-form",
  HOME_PROFILE: "/home/profile",

  // SCHOOL
  INFO_BIOGRAPH: "/school/biograph",
  PERMIT_PAGE: "/school/request-permit",
  PERMIT_DATA_PAGE: "/school/data-permit",
  PERMIT_DETAIL_PAGE: "/school/permit-detail",
  HEALTH_PAGE: "/school/health",
  HEALTH_DETAIL_PAGE: "/school/health-detail",
  ABSENCE_PAGE: "/school/absence",
  ABSENCE_DETAIL_PAGE: "/school/absence-detail",
  VIOLATION_PAGE: "/school/violation",
  VIOLATION_DETAIL_PAGE: "/school/violation-detail",
  ACHIEVEMENT_PAGE: "/school/achievement",
  ACHIEVEMENT_DETAIL_PAGE: "/school/achievement-detail",
  TAHFIDZ_DETAIL_PAGE: "/school/tahfidz-detail",
  TAFAQUH_DETAIL_PAGE: "/school/tafaquh-detail",
  DAILY_REPORT_CARD: "/school/daily-report-card",
  FINAL_EXAM_REPORT_CARD: "/school/final-exam-report-card",
  FINAL_REPORT_CARD: "/school/final-report-card",
  FINAL_REPORT_CARD_MTW: "/school/final-report-card-mtw",
  FINAL_REPORT_CARD_MA: "/school/final-report-card-ma",
  SULUK_PAGE: "/school/data-suluk",

  // OTHER MENU
  MENU_PAYMENT: "/menu/payment",
  MENU_ACADEMIC: "/menu/academic",
  MENU_TAHFIDZ: "/menu/tahfidz",
  MENU_FINANCE: "/menu/finance",
  MENU_DORMITORY: "/menu/dormitory",
  MENU_PERMIT: "/menu/permit",
  MENU_RAPOR: "/menu/report-card",

  // SETTING
  SETTING_UPDATE_ACCOUNT: "/setting/update-account",
  SETTING_CHANGE_PASSWORD: "/setting/change-password",

  // FINANCE
  FINANCE_BILLING_INFO: "/finance/billing-info",
  FINANCE_REQUEST_VA: "/finance/:type/request-va",
  FINANCE_POCKET: "/finance/pocket",
  VA_DATA_PAGE: "/finance/data-va",
  VA_DETAIL_PAGE: "/finance/data-va-detail",
  // DEBT_PAYMENT_PAGE: "/finance/debt",
  CHECKING_ACC_PAGE: "/finance/checking-acc",
  MONTHLY_BILL_PAGE: "/finance/monthly-bill",
  NON_MONTHLY_BILL_PAGE: "/finance/non-monthly-bill",
  DEBT_BILL_PAGE: "/finance/debt-bill",

  // MADING
  MADING_DETAIL: "/mading/detail",

  // MARKETPLACE
  MARKETPLACE_PRODUCT: "/marketplace/product",
  MARKETPLACE_CHECKOUT: "/marketplace/checkout",
  MARKETPLACE_HISTORY: "/marketplace/history",
  MARKETPLACE_HISTORY_DETAIL: "/marketplace/history-detail",
  MARKETPLACE_SETTING: "/marketplace/setting",
};

export const publicRoute = ["/auth/login"];

export const routerRegister = createBrowserRouter([
  {
    path: "/",
    element: <BasePage />,
    errorElement: <NotFoundPage />,
    children: [
      // auth
      {
        path: "auth",
        element: <AuthPage />,
        children: [
          {
            index: true,
            path: "login",
            element: <LoginPage />,
          },
        ],
      },
      // home
      {
        path: "home",
        element: <HomePage />,
        children: [
          {
            index: true,
            path: "dashboard",
            element: <DashboardPage />,
          },
          {
            path: "profile",
            element: <ProfilePage />,
          },
        ],
      },
      // school
      {
        path: "school",
        element: <SchoolPage />,
        children: [
          {
            index: true,
            path: "biograph",
            element: <BiographPage />,
          },
          {
            path: "request-permit",
            element: <PermitPage />,
          },
          {
            path: "data-permit",
            element: <PermitDataPage />,
          },
          {
            path: "permit-detail",
            element: <PermitDetailPage />,
          },
          {
            path: "health",
            element: <HealthDataPage />,
          },
          {
            path: "health-detail",
            element: <HealthDetailPage />,
          },
          {
            path: "absence",
            element: <AbsenceDataPage />,
          },
          {
            path: "absence-detail",
            element: <AbsenceDetailPage />,
          },
          {
            path: "tahfidz",
            element: <TahfidzDataPage />,
          },
          {
            path: "tahfidz-detail",
            element: <TahfidzDetailPage />,
          },
          {
            path: "violation",
            element: <ViolationDataPage />,
          },
          {
            path: "violation-detail",
            element: <ViolationDetailPage />,
          },
          {
            path: "achievement",
            element: <AchievementDataPage />,
          },
          {
            path: "achievement-detail",
            element: <AchievementDetailPage />,
          },
          {
            path: "tafaquh",
            element: <TafaquhDataPage />,
          },
          {
            path: "tafaquh-detail",
            element: <TafaquhDetailPage />,
          },
        ],
      },
      // other menu
      {
        path: "menu",
        element: <SubmenuPage />,
        children: [
          {
            index: true,
            path: "other-menu",
            element: <MenuPage />,
          },
          {
            path: "payment",
            element: <SubmenuPaymentPage />,
          },
          {
            path: "academic",
            element: <SubmenuGradesPage />,
          },
          {
            path: "tahfidz",
            element: <SubmenuTahfidzPage />,
          },
          {
            path: "finance",
            element: <SubmenuFinancePage />,
          },

          {
            path: "permit",
            element: <SubmenuPermitPage />,
          },
        ],
      },
      // setting
      {
        path: "setting",
        element: <SettingPage />,
        children: [
          {
            index: true,
            path: "update-account",
            element: <SettingUpdateAccountPage />,
          },
          {
            path: "change-password",
            element: <SettingChangePasswordPage />,
          },
        ],
      },
      // finance
      {
        path: "finance",
        element: <FinancePage />,
        children: [
          {
            index: true,
            path: ":type/request-va",
            element: <RequestVaPage />,
          },
          {
            path: "pocket",
            element: <PocketInfo />,
          },
          {
            path: "data-va",
            element: <VaDataPage />,
          },
          {
            path: "data-va-detail",
            element: <VaDetailPage />,
          },
          {
            path: "debt",
            element: <DebtPaymentPage />,
          },
          {
            path: "checking-acc",
            element: <CheckingAccDataPage />,
          },
          {
            path: "monthly-bill",
            element: <MonthlyBillPage />,
          },
          {
            path: "non-monthly-bill",
            element: <NonMonthlyBillPage />,
          },
          {
            path: "debt-bill",
            element: <DebtBillPage />,
          },
        ],
      },
      // mading
      {
        path: "mading",
        element: <MadingPage />,
        children: [
          {
            index: true,
            path: "list",
            element: <MadingListPage />,
          },
          {
            path: "detail",
            element: <MadingDetailPage />,
          },
        ],
      },
      // marektplace
      {
        path: "marketplace",
        element: <MarketplacePage />,
        children: [
          {
            index: true,
            path: "product",
            element: <MarketplaceProductPage />,
          },
          {
            path: "checkout",
            element: <MarketplaceCheckoutPage />,
          },
          {
            path: "history",
            element: <MarketplaceHistoryPage />,
          },
          {
            path: "history-detail",
            element: <MarketplaceHistoryDetailPage />,
          },
          {
            path: "setting",
            element: <MarketplaceSettingPage />,
          },
        ],
      },
    ],
  },
]);
